import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
/**
 * This guard is intended to use in /logout-callback route to make logout process seamless.
 * The URI is called by the FusionAuth so that App's token and other user data can be cleaned up after logout from the FusionAuth.
 */
export class LogoutCallbackGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  async canActivate(): Promise<UrlTree> {
    await this.auth.logout();
    return this.router.createUrlTree(['/login']);
  }
}
